import React, { useLayoutEffect, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { IntlProvider } from "react-intl";
import { isLoading, useLoadableSlice } from "../store/shared";

import { loadTranslation } from "./translation.actions";
import normalizeLocale from "./normalizeLocale";
import { changeDOMLangAttribute } from "../utils/changeDOMLangAttribute";
import { getLanguage, getLocale } from "./withIntl.selectors";
import { getTranslation } from "../store/root.selectors";

/*
    Intl accepts locale as BCP-47 language tag: en-US, not en_US
    Let's transform our languages (that are set in appConfig.json) in order to provide backward compatibility
    It may make sense to move this transformation to the store if we want use this value across an app
    but for now it is the only place where it is used
*/
// TODO: need to decide how to deal with this incorrect locales keys that we've been using for a while
export const WithIntl = ({ children }) => {
  const translation = useLoadableSlice(loadTranslation(), getTranslation);
  const fetchedTranslations = useSelector(getLocale);
  const isTranslationLoading = translation ? isLoading(translation) : true;
  const { key, inversedDirection } = useSelector(getLanguage);
  const dispatch = useDispatch();
  const locale = normalizeLocale(key);
  const messages = translation ? translation[locale] : {};

  useEffect(() => {
    !fetchedTranslations && dispatch(loadTranslation());
  }, [fetchedTranslations, dispatch]);

  useLayoutEffect(() => {
    changeDOMLangAttribute(key);

    document.body.classList.remove(inversedDirection ? "ltr" : "rtl");
    document.body.classList.add(inversedDirection ? "rtl" : "ltr");
  }, [inversedDirection, key]);

  if (isTranslationLoading) {
    return null;
  }

  return (
    <IntlProvider key={locale} locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
};
